// TODO: change for prod
export const BASE_URL = 'https://crat-dex-frontend.vercel.app/';
